import { PayloadEpic } from '@/store/epics/epic-types';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { actions, asyncActions } from '@/store/slices';
import { concat, EMPTY, from, of } from 'rxjs';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';
import axios from 'axios-observable';
import { apiEndpoints } from '@/store/constants';
import { WarehouseModel } from '@/models';
import { FetchAllWarehousesPayload } from '@/store/slices/payload-types/warehouse-payload-types';

export const fetchAllWarehousesEpic: PayloadEpic<FetchAllWarehousesPayload, WarehouseModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.warehouses.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.warehouses.setIsLoading(true)),
            fetchWarehouses(payload).pipe(
                switchMap(({ data }) => from([
                    actions.warehouses.setAll(data.results),
                    actions.warehouses.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchAllUsersEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.warehouses.setIsLoading(false)),
        )),
    );
};

const fetchWarehouses = (payload: FetchAllWarehousesPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<WarehouseModel>>(`${apiEndpoints.warehouses()}?${searchParams}`);
};
